import React, {useEffect, useState} from "react";
import PasswordChange from "./PasswordChange";
import SecretQuestionChange from "./SecretQuestionChange";
import CancelButton from "../../Components/Buttons/CancelButton";
import ConfirmPasswordPopup from "./ConfirmPasswordPopup";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import ButtonContainer from "../../Components/CheckableButton/ButtonContainer";
import Communications from "./Communications";
import { API } from "../../API";
import { notify } from "react-notify-toast";
import FormField from "../../Components/FormField/FormField";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import Modal from "../../Components/Modal/Modal";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import Auth from "../../Auth/Auth";

function TeacherAccountForm(props) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [verifiedContactNumber, setVerifiedContactNumber] = useState("")
  const [verifiedEmail, setVerifiedEmail] = useState("")
  const state = props.state;

  useEffect(() => {
    const role = Auth.verifyUserRole()
    switch (role) {
      case "teacher":
        API.getUserSafeData()
          .then(res => {
            if (res.data.user.contact_number && res.data.user.contact_number_verified) {
              setVerifiedContactNumber(res.data.user.contact_number)
            }
            if (res.data.user.email && res.data.user.email_verification_status) {
              setVerifiedEmail(res.data.user.email)
            }
          }).catch((err) => {
            console.log(err)
          }
        )
        break;
      case "customer":
      case "personnel":
        API.getCustomerSafeDataV2()
          .then(res => {
            const mobile = role === "customer" ? res.data.data.mobile : res.data.data.personnel_mobile
            const email = role === "customer" ? res.data.data.email  : res.data.data.personnel_email

            if (mobile && res.data.data.contact_number_verified) {
              setVerifiedContactNumber(mobile)
            }
            if (email && res.data.data.email_verification_status) {
              setVerifiedEmail(email)
            }
          }).catch((err) => {
            console.log(err)
          }
        )
        break;
    }
  })

  const handleRequestOTP = () => {
    const mobile = formatPhoneNumberIntl(verifiedContactNumber)
    API.requestOTP({
      params: {
        email: verifiedEmail,
        mobile: mobile.substring(1),
      }
    })
      .then(function (response) {
        // console.log("res", response.data)
        window.auth_user_id = response.data.auth_user_id
        notify.show("Code sent to your phone")
      })
      .catch(function (error) {
        console.log('error', error)
      })
  }

  const isNumeric = (value) => {
    return /^[0-9]*$/.test(value)
  }

  const confirmDeleteAccount = async () => {
    const codes = document.querySelector('#verifyCode').value
    if (isNumeric(codes)) {

      API.verifyOTP({
        params: {
          id: window.auth_user_id,
          token: codes,
          email: verifiedEmail,
        },
      })
        .then(function (response) {
          API.deleteTeacherAccount()
          notify.show('Account deleted successfully!')
          let userType = window.localStorage.getItem('userType');
          window.localStorage.clear();
          window.localStorage.setItem('userType', userType);
          setTimeout(() => { window.location = "/login" }, 1500);
        })
        .catch(function (error) {
          console.log(error)
          notify.show('Please enter the exact code sent to your phone')
        })
    } else {
      notify.show('Please enter numbers only')
    }
  }

  const onClickDelete = () => {
    if (!verifiedEmail || !verifiedContactNumber) {
      notify.show("Email or contact number not verified")
    } else {
      setShowDeleteModal(true)
      handleRequestOTP()
    }
  }

  return (
    <>
      <div className="row mb-5">
        <div className="col-lg-6">
          <div className="mb-5">
            <PasswordChange
              handleStateChange={props.handleStateChange}
              handleFormFieldChange={props.handleFormFieldChange}
              // handleCheckboxChange={props.handleCheckboxChange}
              state={state}
            />
          </div>
          <div className="small-screen-disappear">
            <Communications
              handleCheckboxChange={props.handleCheckboxChange}
              state={state}
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="mb-5">
            <SecretQuestionChange
              handleStateChange={props.handleStateChange}
              handleFormFieldChange={props.handleFormFieldChange}
              // handleCheckboxChange={props.handleCheckboxChange}
              state={state}
            />
          </div>
          <div className="small-screen-appear">
            <Communications
              handleCheckboxChange={props.handleCheckboxChange}
              state={state}
            />
          </div>
        </div>
      </div>
      <div className="row mb-5">
        {/* <div className="col-lg-6">
          <ConfirmButton>Suspend Account</ConfirmButton>
        </div> */}
        <div className="col">
          <CancelButton
            onClick={onClickDelete}
            // disabled
          >Delete Account</CancelButton>
        </div>
      </div>

      <Modal
        header='Delete Account'
        onClose={() => setShowDeleteModal(!showDeleteModal)}
        className="confirm-number-modal"
        show={showDeleteModal}
      >
        <div className="row m-0 d-flex justify-content-center">
          <div>Warning: this action cannot be reversed.</div>
          <div className="col-md-7 mt-3">
            <FormField
              type="number"
              id="verifyCode"
              name="verifyCode"
              placeholder="Enter the code sent to your mobile phone"
              autoFocus
            />
          </div>
          <div className="col-md-6">
            <CancelButton onClick={() => setShowDeleteModal(!showDeleteModal)}>Cancel</CancelButton>
          </div>
          <div className="col-md-6 padding-for-mobile">
            <ConfirmButton onClick={confirmDeleteAccount}>Confirm</ConfirmButton>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default TeacherAccountForm;